export default {"src":"/_next/static/media/celery.0c64229b.svg","height":22,"width":17,"blurWidth":0,"blurHeight":0};